module.exports = __webpack_public_path__ + "img/EnConstruccion-transformed.64e9ec8a.jpeg";